'use client';

import { WidgetFallback } from '../components/WidgetFallback';

/**
 * Top-level error boundary. Catches errors in any route segment that does not
 * have its own boundary (e.g. the banner / ticker-tape route and the gallery)
 * so a thrown error degrades to a neutral fallback rather than a blank frame.
 */
export default function RootError() {
    return <WidgetFallback />;
}
